import { connect } from 'react-redux';

import { Toasts } from './Toasts.component';

const mapStateToProps = store => ({
  toasts: store.toasts.all,
});

export default connect(mapStateToProps, null)(Toasts);
